import React, { useState, useContext } from "react";
import ColorCubeIcon from "components/Icons/ColorCubeIcon";
import { ContentContext } from "context/Content";
import { useAuth } from "hooks/Auth";
import DropdownMenu from "components/Menus/DropdownMenu";
import { apiGet } from "helpers/Request";
import { packClasses } from "Utils";
import { toast } from "react-hot-toast";

function ExportButton(props) {
    const { state } = useContext(ContentContext);
    const [loading, setLoading] = useState(false);
    const auth = useAuth();

    const exportAs = (type) => {
        const url = "/v4/export/" + state.content.uuid + "/as/" + type;
        setLoading(true);
        apiGet(url, auth.publication)
            .then((resp) => {
                if (!window) {
                    return;
                }
                let ext;
                let data;
                switch (type) {
                    case "html":
                        ext = "html";
                        data = resp;
                        break;
                    case "applenews":
                    case "ceo":
                    case "ceointerchange":
                    case "meilisearch":
                        ext = "json";
                        data = JSON.stringify(resp);
                        break;
                    case "icml":
                        ext = "icml";
                        data = resp;
                        break;
                    case "simplifiedxml":
                        ext = "xml";
                        data = resp;
                        break;
                    case "text":
                    default:
                        ext = "txt";
                        data = resp;
                        break;
                }

                const fileName = `${state.content.slug}.${ext}`;
                // create the data url, inject, click and remove
                const earl = window.URL.createObjectURL(new Blob([data]));
                const tempLink = document.createElement("a");
                tempLink.href = earl;
                tempLink.setAttribute("download", fileName);
                tempLink.setAttribute("target", "_blank");
                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
                toast.success("Content exported");
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.message);
            });
    };

    const buttonLabel = (
        <div className="relative">
            <ColorCubeIcon
                className={packClasses(
                    loading ? " opacity-1" : " opacity-0",
                    "absolute inset-0 mx-auto h-5 w-5 animate-rotate-pulse"
                )}
                key="icn0"
            />

            <span
                className={packClasses(
                    "w-full text-center",
                    loading ? "opacity-0" : "opacity-1"
                )}
            >
                Export
            </span>
        </div>
    );

    return (
        <DropdownMenu
            label={buttonLabel}
            variant="secondary"
            disabled={!state.content.uuid}
            menuItems={[
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={exportAs.bind(null, "html")}
                >
                    Plain HTML
                </button>,
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={exportAs.bind(null, "text")}
                >
                    Plain Text
                </button>,
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={exportAs.bind(null, "icml")}
                >
                    InCopy/InDesign (ICML)
                </button>,
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={exportAs.bind(null, "simplifiedxml")}
                >
                    Simplified XML (XML)
                </button>,
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={exportAs.bind(null, "applenews")}
                >
                    Apple News Format (JSON)
                </button>,
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={exportAs.bind(null, "ceo")}
                >
                    CEO Export Format (JSON)
                </button>,
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={exportAs.bind(null, "ceointerchange")}
                >
                    CEO API Interchange (JSON)
                </button>,
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={exportAs.bind(null, "meilisearch")}
                >
                    Search Service (JSON)
                </button>,
            ]}
        />
    );
}

export default ExportButton;
